import React from "react";
import { computeTooltipPosition } from "../../../../toolTipUsingPortal/toolTipUsingPortal";

const VIEWPORT_PADDING_PX = 8;
const TOOLTIP_OFFSET_PX = 8;
const TOOLTIP_MAX_WIDTH = "220px";

/**
 * Builds fixed tooltip styles for the insurance info icon, clamped inside the viewport.
 * Icons near the right edge open upward/leftward so content is not clipped off-screen.
 *
 * @param anchorRect - Bounding box of the hovered info icon
 * @returns CSS properties for a portal tooltip that will not clip off-screen
 */
export const computeInsuranceInfoTooltipStyle = (
  anchorRect: DOMRect,
): React.CSSProperties => {
  const spaceAbove = anchorRect.top;
  const spaceBelow = window.innerHeight - anchorRect.bottom;
  const openAbove = spaceAbove >= spaceBelow;
  const isNearRightEdge = anchorRect.right > window.innerWidth * 0.55;

  if (isNearRightEdge) {
    return {
      position: "fixed",
      right: Math.max(
        VIEWPORT_PADDING_PX,
        window.innerWidth - anchorRect.right,
      ),
      top: openAbove
        ? Math.max(VIEWPORT_PADDING_PX, anchorRect.top - TOOLTIP_OFFSET_PX)
        : anchorRect.bottom + TOOLTIP_OFFSET_PX,
      transform: openAbove ? "translateY(-100%)" : undefined,
      zIndex: 2147483647,
      maxWidth: TOOLTIP_MAX_WIDTH,
    };
  }

  return computeTooltipPosition(
    anchorRect,
    openAbove ? "top" : "bottom",
    TOOLTIP_OFFSET_PX,
    TOOLTIP_MAX_WIDTH,
  );
};
